let itm = {
  bcg: require('./bcg_festivals.png'),
  items: [
    {
      disable: true,
      bcg: require('./fes/bcg.png'),
      cssStyle: {
        position: 'absolute',
        top: '37.5%',
        left: '17.2%',
        height: '29%',
        width: '32%',
      },
      songFilters: 'Festivals – Christmas',
      songStyle: {
        musicList: {
          zIndex: 1,
          opacity: '1',
          top: '82.2%',
          left: '2.1%',
          width: '80%',
          fontFamily: 'Linotype',
        },
        list: {
          background: 'transparent',
        },
        disableHeader: true,
        textBox: {
          fontFamily: 'Linotype',
          fontSize: '1.41rem',
        },
      },
      elem: [
        {
          bcg: require('./fes/ch_bcg.png'),
          cssStyle: {
            position: 'absolute',
            top: '33%',
            left: '5.2%',
            height: '51%',
            width: '20.5%',
          },
        },
        {
          bcg: require('./fes/ch_bcg2.png'),
          cssStyle: {
            position: 'absolute',
            top: '29%',
            left: '29.5%',
            height: '55%',
            width: '41%',
          },
        },
        {
          bcg: require('./fes/ch_bcg3.png'),
          cssStyle: {
            position: 'absolute',
            top: '36.5%',
            left: '76%',
            height: '48%',
            width: '17%',
          },
        },
      ],
    },
    {
      disable: true,
      bcg: require('./fes/bcg2.png'),
      cssStyle: {
        position: 'absolute',
        top: '37.5%',
        left: '50%',
        height: '29%',
        width: '32%',
      },
      songFilters: 'Festivals – Carnival',
      songStyle: {
        musicList: {
          zIndex: 1,
          opacity: '1',
          top: '82.2%',
          left: '2.1%',
          width: '80%',
          fontFamily: 'Linotype',
        },
        list: {
          background: 'transparent',
        },
        disableHeader: true,
        textBox: {
          fontFamily: 'Linotype',
          fontSize: '1.41rem',
        },
      },
      elem: [
        {
          bcg: require('./fes/car_bcg.png'),
          cssStyle: {
            position: 'absolute',
            top: '33%',
            left: '5.2%',
            height: '51%',
            width: '20.5%',
          },
        },
        {
          bcg: require('./fes/car_bcg2.png'),
          cssStyle: {
            position: 'absolute',
            top: '29%',
            left: '29.5%',
            height: '55%',
            width: '41%',
          },
        },
        {
          bcg: require('./fes/car_bcg3.png'),
          cssStyle: {
            position: 'absolute',
            top: '36.5%',
            left: '76%',
            height: '48%',
            width: '17%',
          },
        },
      ],
    },
    {
      disable: true,
      bcg: require('./fes/bcg3.png'),
      cssStyle: {
        position: 'absolute',
        top: '68%',
        left: '17.2%',
        height: '29%',
        width: '32%',
      },
      songFilters: 'Festivals – Pizza Day',
      songStyle: {
        musicList: {
          zIndex: 1,
          opacity: '1',
          top: '82.2%',
          left: '2.1%',
          width: '80%',
          fontFamily: 'Linotype',
        },
        list: {
          background: 'transparent',
        },
        disableHeader: true,
        textBox: {
          fontFamily: 'Linotype',
          fontSize: '1.41rem',
        },
      },
      elem: [
        {
          bcg: require('./fes/piz_bcg.png'),
          cssStyle: {
            position: 'absolute',
            top: '33%',
            left: '5.2%',
            height: '51%',
            width: '20.5%',
          },
        },
        {
          bcg: require('./fes/piz_bcg2.png'),
          cssStyle: {
            position: 'absolute',
            top: '29%',
            left: '29.5%',
            height: '55%',
            width: '41%',
          },
        },
        {
          bcg: require('./fes/piz_bcg3.png'),
          cssStyle: {
            position: 'absolute',
            top: '36.5%',
            left: '76%',
            height: '48%',
            width: '17%',
          },
        },
      ],
    },
    {
      disable: true,
      bcg: require('./fes/bcg4.png'),
      cssStyle: {
        position: 'absolute',
        top: '68%',
        left: '50%',
        height: '29%',
        width: '32%',
      },
      songFilters: 'Festivals – Easter',
      songStyle: {
        musicList: {
          zIndex: 1,
          opacity: '1',
          top: '82.2%',
          left: '2.1%',
          width: '80%',
          fontFamily: 'Linotype',
        },
        list: {
          background: 'transparent',
        },
        disableHeader: true,
        textBox: {
          fontFamily: 'Linotype',
          fontSize: '1.41rem',
        },
      },
      elem: [
        {
          bcg: require('./fes/e_bcg.png'),
          cssStyle: {
            position: 'absolute',
            top: '33%',
            left: '5.2%',
            height: '51%',
            width: '20.5%',
          },
        },
        {
          bcg: require('./fes/e_bcg2.png'),
          cssStyle: {
            position: 'absolute',
            top: '29%',
            left: '29.5%',
            height: '55%',
            width: '41%',
          },
        },
        {
          bcg: require('./fes/e_bcg3.png'),
          cssStyle: {
            position: 'absolute',
            top: '36.5%',
            left: '76%',
            height: '48%',
            width: '17%',
          },
        },
      ],
    },
  ],
};

export default itm;
